import { render } from "./domain.vue?vue&type=template&id=f74ccb5e"
import script from "./domain.vue?vue&type=script&lang=js"
export * from "./domain.vue?vue&type=script&lang=js"

import exportComponent from "/home/httpd/Repository/PHP/Apps/rijksbrede-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__